import moment from "moment";

import Input from "@components/input/input";
import InputDatePicker from "@components/input/input-datepicker";

const ProgramStepDueDate = ({
  ongoingProgram,
  programStartDate,
  minStepDueDateOffset,
  maxStepDueDateOffset,
  stepDueDateOffset,
  onUpdate,
}: {
  ongoingProgram: boolean;
  programStartDate?: string | null;
  minStepDueDateOffset?: string | null;
  maxStepDueDateOffset?: string | null;
  stepDueDateOffset?: string | null;
  onUpdate: (offset: string | null) => void;
}) => {
  const isDisabled =
    (ongoingProgram && !maxStepDueDateOffset) ||
    (!ongoingProgram && (!programStartDate || !maxStepDueDateOffset));
  return ongoingProgram ? (
    <div className="flex gap-2 items-center">
      <Input
        disabled={isDisabled}
        className="w-24"
        type="number"
        min={minStepDueDateOffset ?? 0}
        step={1}
        max={maxStepDueDateOffset ?? 0}
        aria-label="Compliance program step due date offset"
        value={stepDueDateOffset ?? ""}
        placeholder={
          maxStepDueDateOffset ? `${maxStepDueDateOffset}` : undefined
        }
        onChange={(e) => onUpdate(`${Math.trunc(Number(e.target.value))}`)}
      />
      <div className="text-sm text-gray-600">days after kickoff</div>
    </div>
  ) : (
    <InputDatePicker
      wrapperClassName="w-full"
      disabled={isDisabled}
      minDate={
        programStartDate && minStepDueDateOffset
          ? moment(programStartDate).add(minStepDueDateOffset, "days").toDate()
          : undefined
      }
      maxDate={
        programStartDate && maxStepDueDateOffset
          ? moment(programStartDate).add(maxStepDueDateOffset, "days").toDate()
          : undefined
      }
      date={
        stepDueDateOffset && programStartDate
          ? moment(programStartDate).add(stepDueDateOffset, "days").toDate()
          : null
      }
      onChangeDate={(date) =>
        onUpdate(date ? `${moment(date).diff(programStartDate, "days")}` : null)
      }
      isClearable
      placeholderText={
        programStartDate && maxStepDueDateOffset
          ? moment(programStartDate)
              .add(maxStepDueDateOffset, "days")
              .format("MMM D, YYYY")
          : undefined
      }
      ariaLabelledBy="Compliance program step due date"
    />
  );
};

export default ProgramStepDueDate;
